var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStore = function SvgStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "m2.666 9.335 5.88-5.88a2.67 2.67 0 0 1 1.893-.787h11.12a2.67 2.67 0 0 1 1.894.787l5.88 5.88M5.334 16v10.667a2.667 2.667 0 0 0 2.667 2.666h16a2.667 2.667 0 0 0 2.666-2.666V16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.667,
    d: "M20 29.332v-5.333a2.667 2.667 0 0 0-2.667-2.667h-2.666A2.667 2.667 0 0 0 12 23.999v5.333M2.666 9.332h26.667M29.333 9.332v4a2.666 2.666 0 0 1-2.667 2.667 3.6 3.6 0 0 1-2.12-.84.93.93 0 0 0-1.093 0 3.6 3.6 0 0 1-2.12.84 3.6 3.6 0 0 1-2.12-.84.93.93 0 0 0-1.094 0 3.6 3.6 0 0 1-2.12.84 3.6 3.6 0 0 1-2.12-.84.93.93 0 0 0-1.093 0 3.6 3.6 0 0 1-2.12.84 3.6 3.6 0 0 1-2.12-.84.93.93 0 0 0-1.093 0 3.6 3.6 0 0 1-2.12.84 2.667 2.667 0 0 1-2.667-2.667v-4"
  })));
};
export default SvgStore;